import formBaseMixin from  '../../../components/form/form-base-mixin.js'
import {ROOT_DOMAIN} from "../../../config/config";
import {account, core} from "../../../api/api-endpoints"

export default {
  mixins: [formBaseMixin],
  computed: {
    userPhoto () {
      if (this.fields.photo) {
        return `${ROOT_DOMAIN}${this.fields.photo}`
      }
      return null
    },
    roles () {
      return this.$store.getters.readUrlEndpoint(this.getRolesUrl()).data
    },
    activeOptions () {
      return [
        {id: 1, name: 'Активен'},
        {id: 0, name: 'Не активен'}
      ]
    },
    mosOptions () {
      return this.mos
    },
    mos () {
      return this.$store.getters.readUrlEndpoint(this.getMOEndpoint()).data
    },
    settlements () {
      return this.$store.getters.readUrlEndpoint(this.getSettlementEndpoint()).data
    }
  },
  methods: {
    filterGeoObjects (list, fieldKey, source = []) {
      this.$set(this.fields, fieldKey, [])
      source.forEach(id => {
        for (let i = 0; i < list.length; i++) {
          if (+list[i].id === +id) {
            this.fields[fieldKey].push(id)
            break
          }
        }
      })
      // console.log(fieldKey, this.fields[fieldKey])
    },
    selectAllIfNull (list, fieldKey) {
      if (!this.fields[fieldKey] || !Array.isArray(this.fields[fieldKey])) {
        this.$set(this.fields, fieldKey, [])
      }
      if (this.fields[fieldKey].length < 1) {
        list.forEach(v => {
          this.fields[fieldKey].push(v.id)
        })
      }
    },
    ifSelectAllUnset (list, storeField) {
      if (storeField.length === list.length) {
        storeField = []
      }
    },
    update () {
      if (this.item) {
        this.fields = Object.assign({}, this.item)
        this.fields.activated = +this.item.is_active
        // TODO: in server json department: "null"
        if (this.fields.department === 'null') {
          this.fields.department = ''
        }
      }
    },
    transformFieldsBeforeSend () {
      this.fields.is_active = (+this.fields.activated > 0)
    },
    onSuccess () {
      this.showOnSuccess('Запись сохранена')
      this.unFreezeFrom()
      let routeRedirect = this.getRedirectParams()
      routeRedirect.query = routeRedirect.query || {}
      routeRedirect.query.openUserGroup = this.fields.user_group_id || 0
      this.$router.push(routeRedirect)
    },
    sendForm () {
      this.transformFieldsBeforeSend()
      // edit
      if (this.$route.params && this.$route.params.id) {
        // change status
        if (!this.item.is_active && this.fields.is_active) {
          this.sendFormWithConfirmBox()
          return
        }
        // change email
        if (this.fields.is_active && this.item.email != this.fields.email) {
          this.sendFormWithConfirmBox()
          return
        }
      } else {
        // status active
        if (this.fields.is_active) {
          this.sendFormWithConfirmBox()
          return
        }
      }
      formBaseMixin.methods.sendForm.call(this)
    },
    sendFormWithConfirmBox () {
      if (this.checkSendFormPerms() === false) {
        return false
      }
      let {hasError} = this.formValidator.validate(this)
      if (!hasError) {
        this.$e.confirmBox(
          'На указанный Вами e-mail пользователю будет отправлена ссылка, перейдя по которой он сможет установить пароль',
          ' ',
          'Продолжить'
        ).then(() => {
          formBaseMixin.methods.sendForm.call(this)
        })
      }
    },
    getFilesEndpoint (route) {
      route.query.user_id = this.$route.params.id || -1
      return account.file(route)
    },
    downloadFile (item) {
      return {
        endpoint: core.downloadFile(item.id, 'file'),
        fileName: item.name
      }
    },
  },
  asyncData ({store, route, fromRoute, methods}) {
    let promises = []
    if (methods.getItemEndpoint(route, fromRoute) !== null) {
      promises.push(store.dispatch('updateUrlEndpoint', {endpoint: methods.getItemEndpoint(route, fromRoute)}))
    }

    promises.push(store.dispatch('updateUrlEndpoint', {endpoint: methods.getRolesUrl()}))

    if (promises.length === 0) {
      return Promise.resolve(1)
    }

    if (methods.getMOEndpoint) {
      promises.push(store.dispatch('updateUrlEndpoint', {endpoint: methods.getMOEndpoint()}))
    }

    if (methods.getSettlementEndpoint) {
      promises.push(store.dispatch('updateUrlEndpoint', {endpoint: methods.getSettlementEndpoint()}))
    }

    return Promise.all(promises)
  }
}

